module.exports = __webpack_public_path__ + "img/celery.ef46298d.png";